<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
        <el-button
          v-show="pageState != 2"
          type="primary"
          plain
          class="title-btn"
          @click="cancel"
          ruleForm
          >返回</el-button
        >
      </div>
      <el-steps
        :active="4"
        align-center
        style="border-bottom: 1px solid #e9e9e9; padding-bottom: 20px"
      >
        <el-step title="充电结束时间" :description="rowdata.startTime" />
        <el-step title="占用开始时间" :description="rowdata.actalTime" />
        <el-step title="占用结束时间" :description="rowdata.endTime" />
        <el-step title="订单支付" :description="rowdata.payTime" />
      </el-steps>
      <div class="orderInfo">
        <div class="orderMoney">
          <div>占用时长</div>
          <span class="money" v-if="rowdata.flag">充电中</span>
          <span class="money" v-else>{{ rowdata.time }}</span>
        </div>
        <div class="orderMoney" v-if="!rowdata.flag">
          <div>占用收费</div>
          <span class="money">{{ getFixed2(rowdata.totalMoney) }}</span>
          <span class="col-333">元</span>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">占用信息</span>
      </div>
      <div
        style="width: 90%; margin: 0 auto; padding-top: 26px; padding-top: 26px"
      >
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          form-style="width:calc(50% - 10px);display:inline-block"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户信息</span>
      </div>
      <div style="width: 90%; margin: 0 auto; padding-top: 26px">
        <SForm
          ref="editformref"
          :fields="editformfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          form-style="width:calc(50% - 10px);display:inline-block"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card v-if="pageState == 3" shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
      </div>
      <div style="width: 90%; margin: 0 auto; padding-top: 26px">
        <SForm
          ref="editformref"
          :fields="orderformfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          form-style="width:calc(50% - 10px);display:inline-block"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card v-if="pageState == 2" shadow="never">
      <div slot="header">
        <span class="title">结算处理</span>
      </div>
      <p style="color: #1890ff; font-size: 13px; text-indent: 50px">
        温馨提示：默认结算信息为估算建议值，请确认后再行保存！
      </p>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        inline
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="占用时长" prop="time" style="width: 40%">
          <el-input
            v-model="ruleForm.time"
            placeholder="请输入占用时长"
            @blur="getOverMoney(ruleForm.time)"
            onKeyUp="value=value.replace(/[^\.\d]/g,'')"
          />
        </el-form-item>
        <el-form-item label="超时费用" prop="overMoney" style="width: 40%">
          {{ ruleForm.overMoney }}元
        </el-form-item>
        <el-form-item label="处理原因" prop="reason" style="width: 80%">
          <el-input
            v-model="ruleForm.reason"
            type="textarea"
            :rows="4"
            placeholder="请输入处理原因"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <div v-if="pageState == 2" class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { re } from "semver";

export default {
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: "所属电站",
          type: "div",
          style: "width:100%",
          prop: "stationName",
        },
        {
          label: "占用终端编码",
          type: "div",
          style: "width:100%",
          prop: "connectorId",
        },
        {
          label: "停车缓冲时长",
          type: "div",
          style: "width:100%",
          prop: "freeTimeMin",
        },
        {
          label: "超时计费",
          type: "div",
          style: "width:100%",
          prop: "priceTime",
        },
        {
          label: "关联充电订单",
          type: "div",
          style: "width:100%",
          prop: "orderNo",
        },
        {
          label: "充电结束时间",
          type: "div",
          style: "width:100%",
          prop: "startTime",
        },
      ],
      editformfields: [
        {
          label: "用户账号",
          type: "div",
          style: "width:100%",
          prop: "loginName",
        },
        {
          label: "用户姓名",
          type: "div",
          style: "width:100%",
          prop: "userName",
        },
        {
          label: "归属企业",
          type: "div",
          style: "width:100%",
          prop: "orgName",
        },
      ],
      orderformfields: [
        {
          label: "占用订单号",
          type: "div",
          style: "width:100%",
          prop: "chargeId",
        },
        {
          label: "订单结束原因",
          type: "div",
          style: "width:100%",
          prop: "stopType",
        },
      ],
      ruleForm: {
        id: "",
        time: "",
        overMoney: "",
        reason: "",
      },
      rules: {
        time: [
          {
            required: true,
            message: "请输入占用时长",
            trigger: "blur",
          },
        ],
        reason: [
          {
            required: true,
            message: "请输入处理原因",
            trigger: "blur",
          },
        ],
      },
      id: "",
      pageState: 0,
    };
  },
  mounted() {
    this.getDataDetail();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.ruleForm.id = this.$route.query.id;
    this.pageState = this.$route.query.pageState;
  },
  methods: {
    cancel() {
      localStorage.setItem("tabName", "second");
      this.$router.go(-1);
    },
    onSubmit() {
      let ruleFormBool = false;
      this.$refs["ruleForm"].validate((valid) => {
        ruleFormBool = valid;
      });
      if (ruleFormBool) {
        this.$store.dispatch("form/handle", {
          url: "/admin/occupyorder/stopOrder",
          data: this.ruleForm,
          method: "get",
          callback: (resp) => {
            this.$notify({
              title: "成功",
              message: "保存成功",
              type: "success",
              duration: 1500,
            });
            this.$router.go(-1);
          },
        });
      }
    },
    getOverMoney(val) {
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      const index = val.indexOf(".") + 1;
      let str = val.substr(0, index);
      const str1 = val.substr(index, val.length + 1);
      // if (index == 1) {
      //   if (str1.length > 0) {
      //     str = 0;
      //   } else {
      //     val = 0;
      //   }
      // }
      if (str1) {
        val = str + str1;
      } else {
        val = str;
      }
      if (Number(val) >= 0) {
        this.ruleForm.time = val;
        console.log(val, 999999);
        const time = Math.ceil(
          Number(this.ruleForm.time) / Number(this.rowdata.chargeTime)
        );
        this.ruleForm.overMoney = (Number(this.rowdata.price) * time).toFixed(2);
      } else {
        this.ruleForm.time = "";
        this.ruleForm.overMoney = "";
      }
    },
    getDataDetail() {
      const data = { id: this.id };
      let url = "/admin/occupyorder/getTmpOrderById";
      if (this.pageState == 3) {
        url = "/admin/occupyorder/getOrderById";
      }
      this.$store.dispatch("form/handle", {
        url: url,
        data: data,
        method: "get",
        callback: (resp) => {
          if (resp) {
            // if (resp.pointList && resp.pointList.length > 0) {
            //   resp.pointList.forEach((item) => {
            //     if (item.type == 1) {
            //       resp.startTime = item.time;
            //     } else if (item.type == 2) {
            //       resp.startTime = item.time;
            //     }
            //   });
            // }
            resp.chargeId = resp.occupyNo;
            resp.priceTime = resp.price + "元 / " + resp.chargeTime + " 分钟";
            resp.freeTimeMin = resp.freeTime + "分钟";
            resp.stopType =
              resp.stopType == 1
                ? "正常结束"
                : resp.stopType == 2
                ? "手动结束"
                : "--";
            var hours = parseInt(
              (resp.time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.ceil(
              (resp.time % (1000 * 60 * 60)) / (1000 * 60)
            );
            if (hours == 0) {
              resp.time = minutes + " 分钟 ";
            } else {
              resp.time = hours + "小时" + minutes + " 分钟 ";
            }
            if (resp.startTime === null) {
            } else {
              resp.startTime = this.getTime(resp.startTime);
            }
            if (resp.actalTime === null) {
            } else {
              resp.actalTime = this.getTime(resp.actalTime);
            }
            if (resp.endTime === null) {
            } else {
              resp.endTime = this.getTime(resp.endTime);
            }
            this.rowdata = resp;
          }
        },
      });
    },
    getTime(val) {
      var year = new Date(val).getFullYear();
      var month = new Date(val).getMonth() + 1;
      var date = new Date(val).getDate();
      var hours = new Date(val).getHours();
      var minutes = new Date(val).getMinutes();
      var seconds = new Date(val).getSeconds();
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      // console.log(minutes>10,777);
      var time =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return time;
    },
  },
};
</script>

<style lang="less" scoped>
.orderInfo {
  width: 90%;
  margin: 0 auto;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e9e9e9;
  .orderMoney {
    width: 30%;
    color: #999999;
    font-size: 12px;
    text-align: center;
    .money {
      color: #1890ff;
      font-size: 36px;
    }
  }
}
.col-333 {
  color: #333333;
}
/deep/ .el-form-item {
  .el-form-item__content {
    width: calc(100% - 120px);
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flexJCenter {
  display: flex;
  justify-content: center;
}

.mt-25 {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/occupyDetail.vue